import { Config } from 'browserslist';
import moment from 'moment';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardExtrasWelcomeCard',
})

export default class CmgRewardExtrasWelcomeCard extends Vue {
  isSubmitted: boolean = false;

  get showNewPill(): boolean {
    const launchDate = this.$services.config.getOptinProgramLaunchDate();
    const months = moment().diff(launchDate, 'months');
    return months < 6;
  }

  get extrasIconUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionExtras.default;
  }

  onClickWelcomeCard() {
    this.$services.ui.setModalVisibility('rewardExtrasExplainer', true);
  }
}